module.exports = __webpack_public_path__ + "03_medium_beige.54d95e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_medium_beige.png
// module id = 2bsV
// module chunks = 0